

export const SET_TABLE_CHECK = 'SET_TABLE_CHECK';



// WEBPACK FOOTER //
// ./src/store/mutation-type.js